module.exports = __webpack_public_path__ + "static/media/img_skill_validation_02.fc05fb0b.png";